import { Alert as BasicAlert } from '@bedrock/components';
// import { ButtonProps } from '@bedrock/components/es/Button';
import './index.less';

// interface Props extends ButtonProps {}

export default BasicAlert;
